import { readJsonScript } from './dom';
import type { PublicRuntimeConfig } from './types';

const DEFAULT_LANGS = [
  'en',
  'de',
  'fr',
  'es',
  'it',
  'pt',
  'pl',
  'cs',
  'hu',
  'ro',
  'tr',
  'uk',
  'ru',
];

export function readRuntimeConfig(doc: Document = document): PublicRuntimeConfig {
  const embedded = readJsonScript<Partial<PublicRuntimeConfig>>('quaom-runtime-config', doc) || {};
  const html = doc.documentElement;
  const body = doc.body;
  const environment = normalizeEnvironment(
    embedded.environment || html.dataset.environment || body?.dataset.environment || 'production',
  );

  return {
    apiBase: String(embedded.apiBase || body?.dataset.apiBase || ''),
    apiBaseDev: embedded.apiBaseDev || body?.dataset.apiBaseDev || undefined,
    defaultLang: String(embedded.defaultLang || 'en'),
    supportedLangs: normalizeLangs(embedded.supportedLangs),
    environment,
    buildId: embedded.buildId || readBuildId(doc),
    featureFlags: embedded.featureFlags || {},
  };
}

export function resolveRuntimeApiBase(
  config: PublicRuntimeConfig,
  locationLike: Pick<Location, 'hostname'> = window.location,
): string {
  const host = locationLike.hostname;
  if ((host === 'localhost' || host === '127.0.0.1' || host === '') && config.apiBaseDev)
    return config.apiBaseDev;
  return config.apiBase || config.apiBaseDev || '';
}

function normalizeLangs(value: unknown): string[] {
  if (!Array.isArray(value) || !value.length) return DEFAULT_LANGS;
  return value.map((item) => String(item)).filter(Boolean);
}

function normalizeEnvironment(value: string): PublicRuntimeConfig['environment'] {
  if (value === 'development' || value === 'preview' || value === 'production') return value;
  return 'production';
}

function readBuildId(doc: Document): string | undefined {
  return doc.querySelector<HTMLMetaElement>('meta[name="build"]')?.content || undefined;
}
